import querystring from 'querystring';
import ApiService from '../api/ApiService';

export default async function getVersionDetails(versionId, dateMecYear, dateMecMonth, mileage, page = null) {
  if (!versionId || !dateMecYear || !mileage) throw new Error('api_error_registration_unkown');

  let parameters = dateMecMonth ? `month=${dateMecMonth}` : '';
  parameters = page === 'marketAnalyse' ? `${parameters}&type=rfNoMedian` : parameters;

  parameters += parameters ? '&origin=autobizCarcheck' : 'origin=autobizCarcheck';

  const response = await ApiService(
    'getQuotation',
    {
      versionId,
      dateMecYear,
      mileage,
    },
    querystring.parse(parameters),
  );

  return response.data;
}
